module.exports = __webpack_public_path__ + "media/images/webpage/errors/bg-404-ae15fe9983520604e061d8d2377faff8.webp";